import React from 'react';
import { render } from 'react-dom';

import './style/css/bootstrap.min.css';
import './index.css';

import { sampleText } from './sampleText';
import marked from 'marked';
import { analyticsService } from './services/analyticsService';

class App extends React.Component {
    state = {
        text: sampleText
    };

    componentWillMount() {
        const text = localStorage.getItem('text');

        if (text) {
            this.setState({ text: text });
        }
    }

    componentDidMount() {
        // Track page view on app load
        analyticsService.trackPageView();

        // Track external link clicks
        document.addEventListener('click', this.handleExternalLinkClick);
    }

    componentWillUnmount() {
        // Cleanup event listeners
        document.removeEventListener('click', this.handleExternalLinkClick);
    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem('text', nextState.text);
    }

    // Track clicks on external links
    handleExternalLinkClick = (event) => {
        const link = event.target.closest('a');
        if (link && link.href && link.href.startsWith('http') && !link.href.includes(window.location.hostname)) {
            analyticsService.track('external_link_click', {
                url: link.href
            });
        }
    };

    saveTextAsFile() {
        const textToWrite = this.state.text;
        const textFileAsBlob = new Blob([textToWrite], { type: 'text/plain' });
        const fileNameToSaveAs = "file" + Date.now() + ".md";
        const downloadLink = document.createElement("a");
        downloadLink.download = fileNameToSaveAs;
        downloadLink.innerHTML = "Download File";
        if (window.webkitURL !== null) {
            downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob);
        }
        else {
            downloadLink.href = window.URL.createObjectURL(textFileAsBlob);
            downloadLink.style.display = "none";
            document.body.appendChild(downloadLink);
        }
        downloadLink.click();

        // Track file download event
        analyticsService.track('file_download', {
            filename: fileNameToSaveAs,
            size: textToWrite.length
        });
    }

    editText = (event) => {
        const text = event.target.value;
        this.setState({ text: text });
    };

    // Handle paste event in textarea
    handlePaste = (event) => {
        const pastedText = event.clipboardData.getData('text');
        if (pastedText) {
            analyticsService.track('text_paste', {
                length: pastedText.length
            });
        }
    };

    // Clear all text content
    clearText = () => {
        if (this.state.text.length > 0) {
            analyticsService.track('text_clear', {
                previousLength: this.state.text.length
            });
            this.setState({ text: '' });
        }
    };

    // Copy rendered markdown to clipboard
    copyToClipboard = () => {
        const renderedContent = document.querySelector('.col-sm-6 > div[dangerouslySetInnerHTML]');
        if (renderedContent) {
            const textToCopy = renderedContent.innerText || this.state.text;
            navigator.clipboard.writeText(textToCopy).then(() => {
                analyticsService.track('copy_to_clipboard', {
                    length: textToCopy.length
                });
            }).catch((err) => {
                console.error('Failed to copy:', err);
            });
        }
    };

    renderText = (text) => {
        const renderText = marked(text, { sanitize: true });
        return { __html: renderText };
    };

    render() {
        return (
            <div className="container">
                <h1 className="title">Markdown Realtime viewer</h1>
                <h3 className="title">Made with <a href="https://facebook.github.io/react/">React</a></h3>
                <div className="row">

                    <div className="col-sm-6">
                        <textarea
                            className="form-control"
                            value={this.state.text}
                            rows="30"
                            onChange={(e) => this.editText(e)}
                            onPaste={(e) => this.handlePaste(e)}
                        />
                    </div>

                    <div className="col-sm-6">
                        <div dangerouslySetInnerHTML={this.renderText(this.state.text)} />
                    </div>
                </div>

                <div className="row" style={{ marginTop: '10px' }}>
                    <div className="col-md-4">
                        <button className="form-control btn-primary" onClick={(e) => this.saveTextAsFile()}>
                            Download your markdown file
                        </button>
                    </div>
                    <div className="col-md-4">
                        <button className="form-control btn-success" onClick={(e) => this.copyToClipboard()}>
                            Copy to clipboard
                        </button>
                    </div>
                    <div className="col-md-4">
                        <button className="form-control btn-danger" onClick={(e) => this.clearText()}>
                            Clear all
                        </button>
                    </div>
                </div>

            </div>
        )
    }
}

render(
    <App />,
    document.getElementById('root')
);


/** WEBPACK FOOTER **
 ** ./src/index.js
 **/